import React, { useState } from 'react';
import { Text, TextInput } from 'react-native';
import AdminModal from './AdminModal';
import AdminButton from './AdminButton';
import { modalStyles } from '../pages/LocationManagement/locationModalStyles';
import { AdminColors } from '../constants/adminColors';

export interface RevertModalProps {
  visible: boolean;
  locationName: string;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const RevertModal: React.FC<RevertModalProps> = ({ visible, locationName, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => { onConfirm(reason); setReason(''); };
  const handleClose = () => { setReason(''); onClose(); };

  return (
    <AdminModal
      visible={visible}
      title="Revert to Active"
      onClose={handleClose}
      footer={
        <>
          <AdminButton label="Cancel" variant="secondary" onPress={handleClose} />
          <AdminButton label="Confirm Revert" variant="primary" onPress={handleConfirm} />
        </>
      }
      width={460}
    >
      <Text style={modalStyles.ctx}>
        Revert <Text style={{ fontWeight: '700' }}>{locationName}</Text> to Active? Please provide a reason for retaining this location despite the SAP removal flag.
      </Text>
      <TextInput
        style={modalStyles.textArea}
        placeholder="Enter reason for reverting to active..."
        multiline
        numberOfLines={3}
        placeholderTextColor={AdminColors.gray350}
        value={reason}
        onChangeText={setReason}
      />
    </AdminModal>
  );
};

export default RevertModal;
